import React from 'react'
import videojs from 'video.js'
import 'videojs-vr'
import '../../../node_modules/video.js/dist/video-js.css'
import '../../../node_modules/videojs-vr/dist/videojs-vr.css'

const VrPlayer = () => {
  const videoRef = React.useRef(null)
  const playerRef = React.useRef(null)

  let options = {
    // lookup the options in the docs for more options
    // autoplay: true,
    controls: true,
    responsive: true,
    muted: true,
    loadingSpinner: true,
    autoplay: false,
    liveui: true,
    loop: true,
    controlBar: {
      pictureInPictureToggle: false,
      fullscreenToggle: false,
    },
    // preload: "metadata",
    // fluid: true,
    // aspectRatio: "16:9",
    // fill: true,
    suppressNotSupportedError: true,
    sources: [
      {
        // src: 'https://videojs-vr.netlify.app/samples/eagle-360.mp4',
        // src: TestVideo,
        // type: 'video/mp4',
        src: 'https://doa19e5pbyyx.cloudfront.net/assets/7ef1b9e0-5102-4369-a8e4-b501d329f0ee/hls/master.m3u8',
        // src: 'https://doa19e5pbyyx.cloudfront.net/assets/18997dd6-d223-4236-b462-e671dda9835f/hls/master.m3u8',
        type: 'application/x-mpegURL',
      },
    ],
  }

  React.useEffect(() => {
    // make sure Video.js player is only initialized once
    if (!playerRef.current) {
      const videoElement = videoRef.current
      if (!videoElement) return
      const player = (playerRef.current = videojs(videoElement, options, () => {
        player.mediainfo = player.mediainfo || {}
        player.mediainfo.projection = '360'
        player.vr({
          projection: 'AUTO',
          debug: false,
          forceCardboard: false,
          //   omnitone: Omnitone,
          //   omnitoneOptions: {},
        })
        handlePlayerReady(player)
      }))
    } else {
      // you can update player here [update player through props]
      // const player = playerRef.current;
      // player.autoplay(options.autoplay);
      // player.src(options.sources);
    }
  }, [options, videoRef])

  const handlePlayerReady = (player) => {
    playerRef.current = player

    // player.mediainfo = player.mediainfo || {}
    // player.mediainfo.projection = '360'
    // player.vr({
    //   projection: 'AUTO',
    //   debug: true,
    //   forceCardboard: false,
    // })

    // you can handle player events here
    player.on('waiting', () => {
      // console.log('player is waiting')
    })

    player.on('canplay', () => {
      // console.log('player is canplay')
    })

    player.on('dispose', () => {
      // console.log('player will dispose')
    })
  }

  // Dispose the Video.js player when the functional component unmounts
  React.useEffect(() => {
    const player = playerRef.current

    return () => {
      if (player) {
        player.dispose()
        playerRef.current = null
      }
    }
  }, [playerRef])

  return (
    <div className=" flex justify-center items-center relative w-full h-full">
      <div style={{ width: '1000px', height: '600px' }} className="">
        <div data-vjs-player>
          <video
            ref={videoRef}
            crossOrigin="anonymous"
            className="video-js vjs-fill vjs-big-play-centered object-cove vjs-theme-fantasy"
          />
        </div>
      </div>
    </div>
  )
}

export default VrPlayer
